import { DELIVERY_POINT_TYPE, DeliveryPointType } from '../types/delivery-point.type';

export const DELIVERY_POINT_TYPES: DeliveryPointType[] = Object.values(DELIVERY_POINT_TYPE);

export const DELIVERY_POINT_TYPE_LABELS: Record<DeliveryPointType, string> = {
  relay: 'Point relais',
  eco: 'Éco-acteur',
  entreprise: 'Entreprise',
  conciergerie: 'Conciergerie',
};

export const ALL_DELIVERY_POINT_TYPES = 'all';

export type DeliveryPointTypeFilter = DeliveryPointType | typeof ALL_DELIVERY_POINT_TYPES;

export const ALL_DELIVERY_POINT_SEGMENTS = 'all';
